const STORAGE_KEY = 'ctc-custom-rates-v2';

export type SalaryTypeKey = 'ordinario_inf' | 'ordinario_sup' | 'integral';

export interface CustomRates {
  [conceptName: string]: number;
}

export interface CustomRatesBySalaryType {
  ordinario_inf: CustomRates;
  ordinario_sup: CustomRates;
  integral: CustomRates;
}

import { DEFAULT_RATES_BY_TYPE } from '../utils/constants';

const defaultRates: CustomRatesBySalaryType = DEFAULT_RATES_BY_TYPE;

const LEGACY_KEY_MAP: Record<string, string> = {
  'Interest on Severance': 'Interest Unemployment Fund',
  Prima: 'Salary 13',
  Health: 'Health System',
  Pension: 'Retirement Fund',
  'Labor Risk': 'Labor Risk Insurance',
  CCF: 'Contribucions by employer (Caja de compensacion Familiar)',
  'Life Insurance': 'Life insurance',
  'Prepaid Medicine': 'Medicina Prepagada',
  'Delivery Support': 'Delivery support cost',
  'Connectivity Allowance': 'Connectivity assistance',
};

function normalizeRateKeys(rates: CustomRates): CustomRates {
  const normalized: CustomRates = {};

  for (const [key, value] of Object.entries(rates || {})) {
    const mappedKey = LEGACY_KEY_MAP[key] || key;
    normalized[mappedKey] = value;
  }

  return normalized;
}

function normalizeAllRates(allRates: CustomRatesBySalaryType): CustomRatesBySalaryType {
  return {
    ordinario_inf: normalizeRateKeys(allRates.ordinario_inf || {}),
    ordinario_sup: normalizeRateKeys(allRates.ordinario_sup || {}),
    integral: normalizeRateKeys(allRates.integral || {}),
  };
}

export function getAllCustomRates(): CustomRatesBySalaryType {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      return normalizeAllRates({ ...defaultRates, ...parsed });
    }
  } catch (error) {
    console.error('Error loading custom rates:', error);
  }
  return normalizeAllRates({ ...defaultRates });
}

export function getCustomRates(salaryType?: SalaryTypeKey): CustomRates {
  const allRates = getAllCustomRates();
  if (salaryType) {
    return allRates[salaryType] || {};
  }
  // For backwards compatibility, return empty if no type specified
  return {};
}

export function saveCustomRates(rates: CustomRates, salaryType: SalaryTypeKey): void {
  try {
    const allRates = getAllCustomRates();
    allRates[salaryType] = rates;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(allRates));
  } catch (error) {
    console.error('Error saving custom rates:', error);
  }
}

export function clearCustomRates(salaryType?: SalaryTypeKey): void {
  try {
    if (salaryType) {
      const allRates = getAllCustomRates();
      allRates[salaryType] = {};
      localStorage.setItem(STORAGE_KEY, JSON.stringify(allRates));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch (error) {
    console.error('Error clearing custom rates:', error);
  }
}

export function getSalaryTypeLabel(type: SalaryTypeKey): string {
  const labels: Record<SalaryTypeKey, string> = {
    ordinario_inf: 'Ordinario Inferior',
    ordinario_sup: 'Ordinario Superior',
    integral: 'Integral'
  };
  return labels[type];
}
